import axios from 'axios';
import config from '../config';
import { authHeader } from '../helpers';
import { handleResponse } from './utility';

//================= Content ===================//
export const uploadImageContent = async (formData) => {
  const response = await axios.post(
    `${config.API_URL}/abuddy/image/upload`,
    formData,
    { headers: authHeader() },
  );
  return response.data;
};

export const createContent = async (data) => {
  const response = await axios.post(`${config.API_URL}/abuddy/content`, data, {
    headers: authHeader(),
  });
  return response.data;
};

export const getContents = async (params) => {
  const response = await axios.get(`${config.API_URL}/abuddy/contents`, {
    params,
    headers: authHeader(),
  });
  return response.data;
};

export const getContentNames = async () => {
  const response = await axios.get(`${config.API_URL}/abuddy/contents/names`, {
    headers: authHeader(),
  });
  return response.data;
};

export const getContentById = async (contentId) => {
  const response = await axios.get(
    `${config.API_URL}/abuddy/content/${contentId}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const updateContentById = async (contentId, data) => {
  const response = await axios.put(
    `${config.API_URL}/abuddy/content/edit/${contentId}`,
    data,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const deleteContentById = async (contentId) => {
  const response = await axios.delete(
    `${config.API_URL}/abuddy/content/delete/${contentId}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

//================= Category ===================//
export const getFlexCategories = async (params) => {
  const response = await axios.get(`${config.API_URL}/abuddy/categories`, {
    params,
    headers: authHeader(),
  });
  return response.data;
};

export const getPublishCategoriesByType = async (envType) => {
  const response = await axios.get(
    `${config.API_URL}/abuddy/categories/public/${envType}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const getFlexCategoriesOrder = async (params) => {
  const response = await axios.get(
    `${config.API_URL}/abuddy/categories/order`,
    {
      params,
      headers: authHeader(),
    },
  );
  return response.data;
};

export const getFlexCategoryById = async (id) => {
  const response = await axios.get(`${config.API_URL}/abuddy/category/${id}`, {
    headers: authHeader(),
  });
  return response.data;
};

export const createFlexCategory = async (data) => {
  const response = await axios.post(`${config.API_URL}/abuddy/category`, data, {
    headers: authHeader(),
  });
  return response.data;
};

export const updateFlexCategory = async (id, data) => {
  const response = await axios.put(
    `${config.API_URL}/abuddy/category/${id}`,
    data,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const deleteFlexCategory = async (id) => {
  const response = await axios.delete(
    `${config.API_URL}/abuddy/category/${id}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const updateOrderCategory = async (orderList) => {
  const response = await axios.put(
    `${config.API_URL}/abuddy/category/order`,
    { orderList },
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

//================= Quick-Reply ===================//

export const getQuickReplyItems = async (params) => {
  const response = await axios.get(
    `${config.API_URL}/abuddy/quick-reply-items`,
    {
      params,
      headers: authHeader(),
    },
  );
  return response.data;
};

export const createQuickReplyItem = async (data) => {
  const response = await axios.post(
    `${config.API_URL}/abuddy/quick-reply-items`,
    data,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const deleteQuickReplyItem = async (id) => {
  const response = await axios.delete(
    `${config.API_URL}/abuddy/quick-reply-items/${id}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const getQuickReplyItemById = async (id) => {
  let response = await axios.get(`${config.API_URL}/abuddy/quick-reply-items/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

export const updateQuickReplyItemById = async (id, data) => {
  let response = await axios.put(
    `${config.API_URL}/abuddy/quick-reply-items/${id}`,
    data,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

// =============== Smart - Report ===============

export const getSmartReports = async (params) => {
  return await axios.get(`${config.API_URL}/abuddy/smart-report-items`, {
    params,
    headers: authHeader(),
  })
    .then((res) => res.data)
    .catch(handleResponse);
};

export const deleteSmartReport = async (id) => {
  return await axios.delete(
    `${config.API_URL}/abuddy/smart-report-items/${id}`,
    {
      headers: authHeader(),
    },
  )
    .then((res) => res.data)
    .catch(handleResponse);
};

export const createSmartReport = async (data) => {
  return await axios.post(
    `${config.API_URL}/abuddy/smart-report-items`,
    data,
    {
      headers: authHeader(),
    },
  ).then((res) => res.data)
  .catch((err) => {
    handleResponse(err);
  });
};

export const getSmartReportItemById = async (id) => {
  return await axios.get(`${config.API_URL}/abuddy/smart-report-items/${id}`, {
    headers: authHeader(),
  }).then((res) => res.data)
  .catch((err) => {
    handleResponse(err);
  });
};

export const updateSmartReportItemById = async (id, data) => {
  return await axios.put(
    `${config.API_URL}/abuddy/smart-report-items/${id}`,
    data,
    {
      headers: authHeader(),
    },
  ).then((res) => res.data)
  .catch((err) => {
    handleResponse(err);
  });
};